import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ShieldCheck, Download } from 'lucide-react';
export function CTASection() {
  return <section id="pricing" className="w-full bg-[#0f172a] py-24 px-4 md:px-6" data-id="element-1">
      <div className="max-w-3xl mx-auto text-center" data-id="element-2">
        {/* Objection Handler */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mb-16" data-id="element-3">
          <h3 className="text-xl md:text-2xl font-bold text-[#faf5ef] mb-6" data-id="element-4">
            Und wenn du Angst hast, dass es "eh nichts bringt" …
          </h3>
          <p className="text-[#94a3b8] text-lg mb-8 max-w-2xl mx-auto" data-id="element-5">
            Genau deshalb ist das hier ein System. Weil du nicht mehr im Dunkeln
            tappst. Du wirst nach 14 Nächten entweder:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left" data-id="element-6">
            <div className="bg-[#1e293b] p-6 rounded-xl border border-[#2dd4bf]/20" data-id="element-7">
              <span className="text-[#2dd4bf] font-bold text-xl block mb-2" data-id="element-8">
                A)
              </span>
              <p className="text-[#cbd5e1]" data-id="element-9">Deutlich besser schlafen</p>
            </div>
            <div className="bg-[#1e293b] p-6 rounded-xl border border-[#d4a574]/20" data-id="element-10">
              <span className="text-[#d4a574] font-bold text-xl block mb-2" data-id="element-11">
                B)
              </span>
              <p className="text-[#cbd5e1]" data-id="element-12">
                Glasklar sehen, dass du es abklären solltest — statt noch 12
                Monate zu raten.
              </p>
            </div>
          </div>
          <p className="mt-6 text-[#faf5ef] font-medium" data-id="element-13">
            Beides ist ein Gewinn.
          </p>
        </motion.div>

        {/* Main CTA Card */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-[#1e293b] to-[#0f172a] p-8 md:p-12 rounded-3xl border border-[#d4a574]/30 shadow-2xl relative overflow-hidden" data-id="element-14">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#d4a574] via-[#c8956c] to-[#d4a574]" data-id="element-15"></div>

          <h2 className="text-3xl md:text-4xl font-extrabold text-[#faf5ef] mb-2" data-id="element-16">
            Der Schnarch- & Nasenfrei-Plan
          </h2>
          <p className="text-[#94a3b8] mb-8 text-lg" data-id="element-17">(14 Nächte)</p>

          <div className="mb-8 flex flex-col items-center gap-3" data-id="element-18">
            <span className="inline-block px-3 py-1 rounded-full bg-[#2dd4bf]/15 text-[#2dd4bf] text-sm font-bold border border-[#2dd4bf]/30 tracking-wide" data-id="element-19">
              −66 % Rabatt
            </span>
            <div className="flex items-center justify-center gap-4" data-id="element-20">
              <span className="text-2xl md:text-3xl font-bold text-[#64748b] line-through decoration-2" data-id="element-21">
                19 EUR
              </span>
              <span className="text-5xl md:text-6xl font-black text-[#d4a574] tracking-tight" data-id="element-22">
                6.39 EUR
              </span>
            </div>
            <span className="text-[#2dd4bf] text-sm font-medium" data-id="element-23">
              Du sparst 12.61 EUR
            </span>
          </div>

          <Button variant="primary" fullWidth className="text-xl py-6 mb-6 shadow-[0_0_40px_rgba(212,165,116,0.2)]" onClick={() => {
          window.open('https://www.everstatelabs.com/cart/53336577671501:1', '_blank');
        }} data-id="element-24">
            Jetzt den Plan holen
          </Button>

          <div className="flex items-center justify-center text-[#94a3b8] text-sm space-x-6" data-id="element-25">
            <span className="flex items-center" data-id="element-26">
              <Download className="w-4 h-4 mr-2" data-id="element-27" /> PDF + Tracker
            </span>
            <span className="flex items-center" data-id="element-28">
              <ShieldCheck className="w-4 h-4 mr-2" data-id="element-29" /> Sofortiger Download
            </span>
          </div>

          <div className="mt-8 pt-8 border-t border-[#334155]" data-id="element-30">
            <p className="text-[#cbd5e1] text-sm" data-id="element-31"></p>
          </div>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="mt-16 text-[#64748b] italic font-serif text-lg" data-id="element-32">
          "Du bist jetzt nicht mehr im 'Ich hoffe'-Modus."
        </motion.p>
      </div>
    </section>;
}